import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let respuesta: any;
        let message: string;

        switch(error.status){
            case 400:
                message = "Bad Request.";
            break;
            case 401:
                message = "No cuenta con autorización para este proceso.";
            break;
            case 403:
                message = "No cuenta con autorización para este proceso.";
            break;
            case 404:
                message = "El recurso que desea consumir no existe.";
            break;
            case 500:
                message = "Ups! Algo salio mal.";
            break;
            default:
                message = "Servidor no disponible.";
                break;
        }

        respuesta = {status: error.status, message: message};
        console.error('Error interceptado:', error);
        return throwError(error);
      })
    );
  }
}
